import React, { useState } from 'react';
// import { auth } from '../../firebaseConfig'; // TODO: Firebase config removed

const FeedbackForm = ({ isOpen, onClose }) => {
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  
  // Character limit for messages
  const MAX_CHARS = 500;

  // Prefill email from authenticated user if available
  // React.useEffect(() => {
  //   if (auth.currentUser?.email) {
  //     setEmail(auth.currentUser.email);
  //   }
  // }, []);

  const handleMessageChange = (e) => {
    const text = e.target.value;
    // Ensure the message doesn't exceed the character limit
    if (text.length <= MAX_CHARS) {
      setMessage(text);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    
    try {
      const userEmail = 'user@example.com'; // Placeholder - replace with actual user email from Supabase auth
      // const userEmail = email || 'Anonymous User';
      
      // Get metadata for better feedback context
      const url = window.location.href;
      const userAgent = navigator.userAgent;
      
      console.log('Sending feedback to API...');
      
      // Send feedback using our Resend API endpoint
      const response = await fetch('/api/send-feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: 'User', // Generic name to avoid collecting identifying information
          email: userEmail,
          message,
          url,
          userAgent
        })
      });

      let data;
      try {
        data = await response.json();
      } catch (err) {
        // Handle case where response isn't valid JSON
        console.error('Invalid JSON in response:', err);
        data = { success: false, message: 'Server response error' };
      }

      console.log('Feedback API response:', response.status, data);

      if (response.ok && data.success) {
        setSubmitStatus('success');
        setMessage('');
        
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
        }, 3000);
      } else {
        const errorMsg = data.message || `Error: ${response.status}`;
        console.error('Submission error:', errorMsg);
        setSubmitStatus('error');
        setErrorMessage(errorMsg);
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setSubmitStatus('error');
      setErrorMessage(error.message || 'Network error, please try again');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  // Calculate remaining characters
  const charsRemaining = MAX_CHARS - message.length;
  // Determine the color for the counter
  const counterColor = 
    charsRemaining > MAX_CHARS * 0.3 ? 'text-gray-400' :
    charsRemaining > MAX_CHARS * 0.1 ? 'text-yellow-500' : 
    'text-red-500';

  return (
    <div 
      className="fixed bottom-20 right-6 md:bottom-24 md:right-8 z-50 w-80 md:w-96 
                 shadow-lg rounded-xl bg-white border-2 border-blue-100 overflow-hidden"
    >
      {/* Header */}
      <div className="bg-blue-100 p-4 flex justify-between items-center">
        <h3 className="text-blue-700 font-medium">Feedback ou Question</h3>
        <button 
          onClick={onClose}
          className="text-blue-700 hover:text-blue-800 transition-colors focus:outline-none"
          aria-label="Fermer"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>

      {/* Content */}
      <div className="p-4">
        {submitStatus === 'success' ? (
          <div className="text-center py-6">
            <div className="rounded-full bg-green-50 w-12 h-12 mx-auto flex items-center justify-center mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <h4 className="text-lg font-medium text-gray-800 mb-1">Merci pour votre message!</h4>
            <p className="text-sm text-gray-600">Nous vous répondrons dès que possible.</p>
          </div>
        ) : submitStatus === 'error' ? (
          <div className="text-center py-6">
            <div className="rounded-full bg-red-50 w-12 h-12 mx-auto flex items-center justify-center mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <h4 className="text-lg font-medium text-gray-800 mb-1">Une erreur est survenue</h4>
            {errorMessage && (
              <p className="text-sm text-red-600 mb-2">{errorMessage}</p>
            )}
            <p className="text-sm text-gray-600">Veuillez réessayer ultérieurement.</p>
            <button 
              onClick={() => setSubmitStatus(null)}
              className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Réessayer
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg text-sm text-blue-700">
              Dites-nous comment nous pouvons améliorer votre expérience sur clicdroits.info ! Nous vous répondrons par courriel (mais pas pour des questions juridiques personnelles).
            </div>
            
            {/* Email Field - New required input */}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Votre courriel
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border border-slate-200 rounded-lg focus:border-blue-400 
                         focus:ring-1 focus:ring-blue-400 text-sm"
                placeholder="exemple@domaine.com"
                required
              />
            </div>
            
            <div className="relative">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                Votre message
              </label>
              <textarea
                id="message"
                value={message}
                onChange={handleMessageChange}
                className="w-full h-32 p-3 border border-slate-200 rounded-lg focus:border-blue-400 
                         focus:ring-1 focus:ring-blue-400 text-sm resize-none"
                placeholder="Posez une question sur le fonctionnement du site ou partagez vos commentaires. Merci de ne pas inclure d'informations personnelles qui pourraient vous identifier."
                maxLength={MAX_CHARS}
                required
              ></textarea>
              
              {/* Character counter */}
              <div className={`text-xs mt-1 text-right ${counterColor}`}>
                {charsRemaining} caractères restants
              </div>
            </div>
            
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                       transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Envoi...
                </span>
              ) : "Envoyer"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackForm;
